import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from "firebase/storage";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { firebaseStorage } from "./firebase";
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";

const getAdjuntos = functionsHttpsCallable("ape_listadoAdjuntos");

export const deleteFile = async (path, fileName) => {
  const imgRef = ref(firebaseStorage, `${path}/${fileName}`);
  try {
    await deleteObject(imgRef);
    console.log("File deleted");
  } catch (error) {
    console.log(error);
  }
};

export const FirebaseStorageUploader = async (files, path) => {
  try {
    let list;
    for (const file of files) {
      const listRef = ref(firebaseStorage, `${path}/${file.name}`);
      await uploadBytes(listRef, file);
      list.push({ name: file.name });
    }
    return list;
  } catch (error) {
    console.log(error);
  }
};

export const singleFileUploader = async (file, path, name) => {
  try {
    let list = [];
    const listRef = ref(firebaseStorage, `${path}/${name}`);
    await uploadBytes(listRef, file);
    list.push({ name: name });
    console.log("File uploaded!");
    return list;
  } catch (error) {
    console.log(error);
  }
};

export const getFileList = async (path) => {
  let fileList = [];
  const listRef = ref(firebaseStorage, path);
  const list = await listAll(listRef);
  list.items.forEach((item, index) => {
    fileList.push({ fileName: item.name });
  });
  return fileList;
};

export const getFileZip = async (path) => {
  var jszip = new JSZip();
  const listRef = ref(firebaseStorage, path);
  const list = (await listAll(listRef)).items;
  let downloadUrls = [];
  for (const item of list) {
    const tempRef = ref(firebaseStorage, item.fullPath);
    const newURL = await getDownloadURL(tempRef);
    downloadUrls.push(newURL);
  }
  // const downloadUrls = await Promise.all(
  //     list.map(async ({ fullPath }) => {
  //         const tempRef = ref(storage, fullPath);
  //         await getDownloadURL(tempRef)
  //     })
  // );
  const downloadedFiles = await Promise.all(
    downloadUrls.map((url) => fetch(url).then((res) => res.blob()))
  );
  downloadedFiles.forEach((file, i) => jszip.file(list[i].name, file));
  const content = await jszip.generateAsync({ type: "blob" });
  saveAs(content, path);
};

export const getFinalFileZip = async (path, userData) => {
  let adjuntos = undefined;
  if (userData) {
    adjuntos = await getAdjuntos({
      cod_empr: userData.codigoEmpresa,
      roles: userData.roles,
    });
  }
  console.log("adjuntos", adjuntos.data.data);
  var jszip = new JSZip();
  const documentoIdentidadKey = ["CEDULA"];
  const hojaDeVidaKey = ["HOJA_DE_VIDA"];
  const fotoKey = ["FOTO"];
  const documentosContractualesKey = [
    "CONTRATO",
    "DOCUMENTOS_CONTRACTUALES",
    "MANUAL_FUNCIONES",
    "INDUCCIONES",
  ];
  const afiliacionesKey = [
    "EXAMENES",
    "ARL",
    "EPS",
    "CAJA_DE_COMPENSACION",
    "VACUNAS",
    "FONDO_PENSIONES",
    "CESANTIAS",
    "CERTIFICADO_BANCARIO",
  ];
  const procesoSeleccionKey = [
    "LISTA_CHEQUEO",
    "ANILLO",
    "CERTIFICADO_INEXISTENCIA",
    "PERFIL_CARGO",
    "VALIDACION",
    "AUTORIZACION_ANTECEDENTES",
    "CONFLICTO_INTERES",
    "ACEPTACION_PROCESO",
    "RESPUESTA_INSPEKTOR",
    "RESPUESTA_ESTUDIO_SEGURIDAD",
    "RESPUESTA_POLIGRAFIA",
    "PRUEBAS_TECNICA",
    "PRUEBAS_HB",
    "PRUEBAS_HSEQ",
    "ENTREVISTA",
  ];
  const desvinculacionKey = [];
  var docIdentidad = jszip.folder("Documento de Identidad");
  var hv = jszip.folder("Hoja de Vida");
  var foto = jszip.folder("Foto");
  var docContractual = jszip.folder("Documentos Contractuales");
  var afiliaciones = jszip.folder("Examen y Afiliaciones");
  var procesoSeleccion = jszip.folder("Proceso de Selección");
  var desvinculacion = jszip.folder("Desvinculación");
  var otros = jszip.folder("Otros");
  const listRef = ref(firebaseStorage, path);
  const list = (await listAll(listRef)).items;
  let downloadUrls = [];
  for (const item of list) {
    const tempRef = ref(firebaseStorage, item.fullPath);
    const newURL = await getDownloadURL(tempRef);
    downloadUrls.push(newURL);
  }
  const downloadedFiles = await Promise.all(
    downloadUrls.map((url) => fetch(url).then((res) => res.blob()))
  );
  downloadedFiles.forEach((file, i) => {
    if (adjuntos && adjuntos.data.data.includes(list[i].name.split(".")[0])) {
      if (documentoIdentidadKey.includes(list[i].name.split(".")[0]))
        docIdentidad.file(list[i].name, file);
      else if (hojaDeVidaKey.includes(list[i].name.split(".")[0]))
        hv.file(list[i].name, file);
      else if (fotoKey.includes(list[i].name.split(".")[0]))
        foto.file(list[i].name, file);
      else if (documentosContractualesKey.includes(list[i].name.split(".")[0]))
        docContractual.file(list[i].name, file);
      else if (afiliacionesKey.includes(list[i].name.split(".")[0]))
        afiliaciones.file(list[i].name, file);
      else if (procesoSeleccionKey.includes(list[i].name.split(".")[0]))
        procesoSeleccion.file(list[i].name, file);
      else if (desvinculacionKey.includes(list[i].name.split(".")[0]))
        desvinculacion.file(list[i].name, file);
      else otros.file(list[i].name, file);
    }
  });
  const content = await jszip.generateAsync({ type: "blob" });
  saveAs(content, path);
};

export const getDownloadURLAPI = async (path, fileName) => {
  const listRef = ref(firebaseStorage, `${path}/${fileName}`);
  let downloadLink = await getDownloadURL(listRef);
  return downloadLink;
};

export const getDownloadURLV2 = async (path) => {
  const listRef = ref(firebaseStorage, path);
  let downloadLink = await getDownloadURL(listRef);
  return downloadLink;
};
